<template>
  <div class="reader">
    <h1>Scan a event QR code</h1>
    <QrcodeStream @decode="onDecode" class="qr-reader"></QrcodeStream>
  </div>
</template>

<script>
// import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'
import { QrcodeStream } from 'vue-qrcode-reader'
export default {
  name: 'reader',
   components: {
    QrcodeStream,
    // QrcodeDropZone,
    // QrcodeCapture
  },
  methods: {
    onDecode (decodedString) {
      let to = decodedString.replace(this.baseUrl, '')
      // if (confirm('Do you want to start the training')) {
        this.$router.push(to)
      // }
    }
  },
  computed: {
    baseUrl () {
      return this.$store.state.baseUrl
    },
  }
}
</script>

<style lang="scss" scoped>
.reader {
  padding: 15px;
}
.qr-reader {
  max-height: 60vh;
}
</style>